import React, { useEffect, useRef } from "react";
import { Button, EmptyState, Skeleton } from "../ui";
import "../../styles/content.css";

/** กริดการ์ดพร้อม skeleton / error / empty / ปุ่มโหลดเพิ่ม */
export default function Grid({ loading, error, count, children, empty, onRetry, hasMore, onMore, moreLoading, skeletons = 8 }) {
  const sentinel = useRef(null);
  useEffect(() => {
    const el = sentinel.current;
    if (!el || !hasMore || moreLoading || typeof IntersectionObserver === "undefined") return undefined;
    const io = new IntersectionObserver((es) => es[0].isIntersecting && onMore?.(), { rootMargin: "300px" });
    io.observe(el);
    return () => io.disconnect();
  }, [hasMore, moreLoading, onMore, count]);
  if (error) {
    return (
      <EmptyState icon="⚠️" title="โหลดข้อมูลไม่สำเร็จ" action={onRetry ? <Button onClick={onRetry}>ลองใหม่</Button> : null}>
        <span className="error-text">{error}</span>
      </EmptyState>
    );
  }
  if (loading) return <div className="grid-cards">{Array.from({ length: skeletons }, (_, i) => <Skeleton key={i} height={260} radius={16} />)}</div>;
  if (!count) return empty || <EmptyState icon="🔎" title="ไม่พบตัวละครที่ตรงเงื่อนไข">ลองล้างตัวกรองหรือเปลี่ยนคำค้น</EmptyState>;
  return (
    <>
      <div className="grid-cards">{children}</div>
      {hasMore ? <div ref={sentinel} className="center mt-16"><Button onClick={onMore} disabled={moreLoading}>{moreLoading ? "กำลังโหลด..." : "โหลดเพิ่ม"}</Button></div> : null}
    </>
  );
}
